import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-acceptedrequest-card',
  templateUrl: './helpbutton-reports-acceptedrequest-card.component.html',
  styleUrls: ['./helpbutton-reports-acceptedrequest-card.component.scss']
})
export class HelpbuttonReportsAcceptedrequestCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
